import { OldTextEntityInterface } from 'common/types/entities/OldEntityInterface'
import { TextInterface } from 'common/types/entities/TextInterface'
import { createText } from 'src/shared/entities/text/create-text'
import { migrateReadOnly } from 'tools/commands/migrate/utils/migrateUtils'
import {
  migrateMargin,
  migrateMobileMargin,
  migratePadding,
} from '../utils/migrateUtils'

export const unsupportedBlockTypes = [
  'header-one',
  'header-two',
  'header-three',
  'header-four',
  'header-five',
  'header-six',
]

export function migrateText(entity: OldTextEntityInterface): TextInterface {
  const text = createText(entity.parentId, entity.masterBlockId)

  text.id = entity.id
  if (entity.isMasterBlockRoot) {
    text.isMasterBlockRoot = true
  }
  let rawContentState = entity.options.rawContentState
  for (const type of unsupportedBlockTypes) {
    if (rawContentState?.includes(`"type":"${type}"`)) {
      rawContentState = rawContentState.replace(
        `"type":"${type}"`,
        `"type":"unstyled"`,
      )
    }
  }

  text.rawContentState = rawContentState
  text.content = entity.content || ''

  migrateMargin(text, entity)

  if (entity.styles.padding) {
    text.padding = migratePadding(entity.styles.padding)
  }

  if (entity.options.appearance) {
    text.appearance = entity.options.appearance
  }

  text.htmlAttrId = entity.options.attrId
  text.textAlign = entity.styles.textAlign
  text.fontFamily = entity.styles.fontFamily
  text.fontWeight = entity.styles.fontWeight
  text.fontStyle = entity.styles.fontStyle

  if (entity.styles.backgroundColor) {
    text.backgroundColor = entity.styles.backgroundColor
  }

  if (
    entity.styles.letterSpacing &&
    !isNaN(parseInt(entity.styles.letterSpacing))
  ) {
    text.letterSpacing = parseInt(entity.styles.letterSpacing)
  }
  if (entity.styles.fontSize && !isNaN(parseInt(entity.styles.fontSize))) {
    text.fontSize = parseInt(entity.styles.fontSize)
  }
  if (entity.styles.lineHeight && !isNaN(parseInt(entity.styles.lineHeight))) {
    text.lineHeight = parseInt(entity.styles.lineHeight)
  }

  // MOBILE SETTINGS
  if (
    entity.mobileStyles.letterSpacing &&
    !isNaN(parseInt(entity.mobileStyles.letterSpacing))
  ) {
    text.mobileLetterSpacing = parseInt(entity.mobileStyles.letterSpacing)
  }
  if (
    entity.mobileStyles.fontSize &&
    !isNaN(parseInt(entity.mobileStyles.fontSize))
  ) {
    text.mobileFontSize = parseInt(entity.mobileStyles.fontSize)
  }
  if (
    entity.mobileStyles.lineHeight &&
    !isNaN(parseInt(entity.mobileStyles.lineHeight))
  ) {
    text.mobileLineHeight = parseInt(entity.mobileStyles.lineHeight)
  }

  if (entity.mobileStyles.padding) {
    text.mobilePadding = migratePadding(entity.mobileStyles.padding)
  }

  migrateMobileMargin(text, entity)

  text.mobileFontFamily = entity.mobileStyles.fontFamily
  text.mobileFontWeight = entity.mobileStyles.fontWeight
  text.mobileFontStyle = entity.mobileStyles.fontStyle

  if (entity.mobileStyles.backgroundColor) {
    text.mobileBackgroundColor = entity.mobileStyles.backgroundColor
  }

  if (entity.mobileStyles.textAlign) {
    text.mobileTextAlign = entity.mobileStyles.textAlign
  }

  migrateReadOnly(text, entity)

  return text
}
